export const CREATE_BANK_SLIP_ENTRY  = 'CREATE_BANK_SLIP_ENTRY';
export const GET_BANK_SLIP_ENTRIES  = 'GET_BANK_SLIP_ENTRIES';
export const GET_AVAILABLE_BANK_RECEIPT_TRANSACTION  = 'GET_AVAILABLE_BANK_RECEIPT_TRANSACTION';
export const BANK_SLIP_ENTRY_REQUEST  = 'BANK_SLIP_ENTRY_REQUEST';
export const DELETE_BANK_SLIP_ENTRY  = 'DELETE_BANK_SLIP_ENTRY';
export const UPDATE_BANK_SLIP_ENTRY  = 'UPDATE_BANK_SLIP_ENTRY';
export const BANK_SLIP_ENTRY_REQUEST_FAILURE  = 'BANK_SLIP_ENTRY_REQUEST_FAILURE';
export const GET_BANK_SLIP_ENTRY_PAGE  = 'GET_BANK_SLIP_ENTRY_PAGE';
export const BANK_SLIP_ENTRY_REQUEST_SUCCESS  = 'BANK_SLIP_ENTRY_REQUEST_SUCCESS';